import services from '@/config/services'

export default class UtilityBilancioService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getSaldiByYear(year){
    let item = {}

    const url = `${this.baseUrl}/utility/bilancio/${year}/saldi`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getSaldiByDate(dates){
    let item = {}

    const url = `${this.baseUrl}/utility/bilancio/saldi/search`
    try {
      let res = await this.http.post(url, {
        filters: dates
      })
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

}
